import { Button, Table, Switch, Spin, Modal, message, Select, Form, Typography, Space, Badge, Tooltip, Empty } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import { getColumnSearchProps } from "../../../utils/tables";
import Header from "../../../components/HeaderList";
import { selectUser } from "../../../redux/slices/user";
import { ReactComponent as Edit } from "../../../assets/icons/edit.svg";
import { ReactComponent as Trash } from "../../../assets/icons/trash.svg";
import Editor from "./Editor";
import styles from "../styles/BranchesUI.module.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const { Option } = Select;
const { Text } = Typography;

const BranchesUI = (props) => {
  const {
    loading,
    branches,
    areas,
    branch,
    openEditor,
    editorVisible,
    closeEditor,
    initialFetch,
    // handleTakeOut,
    // handleDelivery,
    // handleHotStop,
    // handleActiveUber,
    handleServiceToggle,
    newBranch,
    handleBranch,
    confirmDelete,
  } = props;
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedRowKey, setSelectedRowKey] = useState(null);
  const [configModalVisible, setConfigModalVisible] = useState(false);
  const [configRecord, setConfigRecord] = useState(null);
  const [form] = Form.useForm();
  const user = useSelector(selectUser);
  const navigate = useNavigate();
  const hasPermission = (type) => {
    return user.rols.includes(type);
  };

  const handleSwitch = (checked, record) => {
    if (checked) {
      handleServiceToggle(record.id, 'uber', record.uber, null, null);
    } else {
      setSelectedRowKey(record.id);
      setModalVisible(true);
    }
  };

  const closeModal = () => {
    setModalVisible(false);
    form.resetFields();
  }

  const handleModalOk = async () => {
    try {
      const values = await form.validateFields();
      // handleActiveUber(selectedRowKey, values.razon, values.tiempo_off, false);
      handleServiceToggle(selectedRowKey, 'uber', true, values.razon, 1440);
      setModalVisible(false);
      form.resetFields();
    }
    catch (error) {
      console.error(error);
      message.error('Error al enviar datos');
    }
  };

  const areasList = areas.map(x => { return { text: x.nombre, value: x.id } });

  const getAreaName = (id) => {
    const index = areasList.findIndex((el) => el.value === id);
    if (index > -1) {
      return areasList[index].text;
    }
    return "-";
  };

  const openConfigModal = (record) => {
    setConfigRecord(record);
    setConfigModalVisible(true);
  };

  // Get the live record from branches state so switches update in real time
  const liveConfigRecord = configRecord
    ? branches.find(b => b.id === configRecord.id) || configRecord
    : null;

  const columns = [
    {
      title: "Sucursal",
      dataIndex: "zone",
      ...getColumnSearchProps("zone"),
      render: (val, record) => (
        <div>
          <Text strong style={{ textTransform: "uppercase" }}>{val || "-"}</Text>
          {record.address && (
            <div>
              <Text type="secondary" style={{ fontSize: 12 }}>{record.address}</Text>
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Área",
      align: "center",
      dataIndex: "area",
      filters: areasList,
      filterMultiple: true,
      onFilter: (value, record) => record.area === value,
      render: (val) => getAreaName(val),
    },
    {
      title: "Teléfono",
      dataIndex: "phone",
      align: "center",
    },
    {
      title: "Servicios",
      align: "center",
      render: (_, record) => {
        const hasUber = record.uber_id !== null;
        const services = [
          { key: "take_out", label: "Take Out", active: record.take_out, color: record.take_out ? 'green' : 'red' },
          { key: "delivery", label: "Delivery", active: record.delivery, color: record.delivery ? 'green' : 'red' },
          { key: "uber", label: "Uber", active: hasUber ? record.uber : null, color: hasUber ? (record.uber ? 'green' : 'red') : 'gray' },
        ];

        return (
          <Space direction="vertical" align="center" size="small">
            <Space size={4}>
              {services.map(s => {
                if (!hasUber && s.key === "uber") {
                  return (
                    <Tooltip key={s.key} title={`${s.label}: No configurado`}>
                      <Badge status="default" />
                    </Tooltip>
                  )
                }
                return (
                  <Tooltip key={s.key} title={`${s.label}: ${s.active ? 'Activo' : 'Inactivo'}`}>
                    <Badge color={s.active ? 'green' : 'red'} />
                  </Tooltip>
                )
              })}
            </Space>
            <Button
              type="primary"
              icon={<SettingOutlined />}
              size="small"
              onClick={() => openConfigModal(record)}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
              Configurar
            </Button>
          </Space>
        );
      },
    },
    /*
    {
      title: "HOT STOP",
      align: "center",
      dataIndex: "hotstop",
      filters: [
        {
          text: "Activo",
          value: 1,
        },
        {
          text: "Inactivo",
          value: 0,
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => record.hotstop === value,
      render: (val, record) => (
        <Switch checked={val} onChange={() => handleHotStop(record.id, val)} />
      ),
    },
    */
    {
      title: "Editar",
      align: "center",
      dataIndex: "id",
      render: (id, record) => (
        <div className={styles.actions}>
          <div className={styles.edit} onClick={() => openEditor(record)}>
            <Edit />
          </div>
          {
            hasPermission("settings") && (
              <>
                <div className={styles.divider} />
                <div className={styles.delete} onClick={() => confirmDelete(id)}>
                  <Trash />
                </div>
              </>
            )
          }
        </div>
      ),
    },
  ];

  return (
    <div className={styles.view}>
      {hasPermission("settings") ? (
        <Header
          title="Sucursales"
          actions={
            <div className={styles.buttonBranch}>
              <Button
                onClick={newBranch}
                type="primary"
                size="large"
                className="main-button"
              >
                NUEVA SUCURSAL
              </Button>
              <Button
                onClick={() => navigate('sucursal-emergencia')}
                type="primary"
                size="large"
                className="main-button"
              >
                SUCURSAL EMERGENCIA
              </Button>
            </div>
          }
        />
      ) : (
        <Header
          title="Información de la Sucursal" />
      )}

      {loading ? (
        <div className={styles.loader}>
          <Spin size="large" />
        </div>
      ) : (
        <>
          {(!branches || branches.length === 0) ? (
            <Empty description="No hay sucursales para mostrar" style={{ margin: '40px 0' }} />
          ) : (
            <Table columns={columns} dataSource={branches} rowKey="id" scroll={{ x: 1000 }} />
          )}
        </>
      )}

      {/* Modal Editor de Sucursal */}
      <Modal
        destroyOnClose
        closable={false}
        visible={editorVisible}
        footer={false}
        onCancel={closeEditor}
        width={950}
      >
        <Editor
          close={closeEditor}
          branch={branch}
          areas={areas}
          user={user}
          initialFetch={initialFetch}
          handleBranch={handleBranch}
        />
      </Modal>

      {/* Modal Configurar Servicios */}
      <Modal
        title={`Servicios - ${liveConfigRecord?.zone || ''}`}
        visible={configModalVisible}
        onCancel={() => {
          setConfigModalVisible(false);
          setConfigRecord(null);
        }}
        footer={[
          <Button key="close" type="primary" onClick={() => {
            setConfigModalVisible(false);
            setConfigRecord(null);
          }}>
            Cerrar
          </Button>,
        ]}
      >
        {liveConfigRecord && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            <Text type="secondary">
              Activa o desactiva los servicios disponibles para esta sucursal:
            </Text>
            <Space align="center" style={{ justifyContent: 'space-between', width: '100%' }}>
              <Text strong>Take Out</Text>
              <Switch
                checked={liveConfigRecord.take_out}
                onChange={() => handleServiceToggle(liveConfigRecord.id, 'take_out', liveConfigRecord.take_out)}
              />
            </Space>
            <Space align="center" style={{ justifyContent: 'space-between', width: '100%' }}>
              <Text strong>Delivery</Text>
              <Switch
                checked={liveConfigRecord.delivery}
                onChange={() => handleServiceToggle(liveConfigRecord.id, 'delivery', liveConfigRecord.delivery)}
              />
            </Space>
            {liveConfigRecord.uber_id?.length > 0 && (
              <Space align="center" style={{ justifyContent: 'space-between', width: '100%' }}>
                <Text strong>Uber Eats</Text>
                <Switch
                  checked={liveConfigRecord.uber}
                  onChange={(checked) => handleSwitch(checked, liveConfigRecord)}
                />
              </Space>
            )}
          </div>
        )}
      </Modal>

      {/* Modal Motivo Uber */}
      <Modal
        destroyOnClose
        closable={false}
        title="Motivo de Desactivar Uber Eats"
        visible={modalVisible}
        onOk={handleModalOk}
        onCancel={closeModal}
        okText="Enviar"
        cancelText="Cerrar"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="razon"
            label="Razón de desactivación"
            rules={[{ required: true, message: 'Selecciona una razón' }]}
          >
            <Select placeholder="Selecciona una razón">
              <Option value="maintenance">Mantenimiento</Option>
              <Option value="otros">Otros</Option>
              <Option value="Energy">Fallo de luz</Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default BranchesUI;
